import { Component } from '@angular/core';
import { DeviceService } from 'projects/max/dfup-storeupweb-fe/src/app/service/device.service';
import { menuItems } from './menu';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
  protected readonly menuItems = menuItems;

  constructor(public deviceSvc: DeviceService) {
  }
}


